<script>
    import app from "./stores/app";
    import {formatDate} from './lib/lib.js';
    import {router} from './router/Router.svelte';
    import {getCreditsHistory,ClientCreditsHistorySave} from "./requests";
    import TableHeader from './controls/TableHeader.svelte';
    import CreditsHistoryRow from './CreditsHistoryRow.svelte';

    let historyList= [];
    let totalPrice = 0;
    let totalPayment = 0;
    let totalRest = 0;
    let loaded = false;

    let sort_key = 'lastname';
    let sort_way = 'ASC';

    let table_columns = [
        {key: 'lastname', name: 'Πελάτης', sortable: true, sort_way: 'ASC', align: ''},
        {key: 'username', name: 'Όνομα χρήστη', sortable: true, sort_way: '', align: ''},
        {key: 'date_created', name: 'Ημερομηνία', sortable: true, sort_way: '', align: ''},
        {key: 'credits', name: 'Μονάδες', sortable: true, sort_way: '', align: ''},
        {key: 'credit_price', name: 'Τιμή μονάδας', sortable: true, sort_way: '', align: ''},
        {key: 'total_price', name: 'Σύνολο', sortable: true, sort_way: '', align: ''},
        {key: 'invoice', name: 'Τιμολόγιο', sortable: true, sort_way: '', align: ''},
        {key: 'payed', name: 'Πληρώθηκε', sortable: true, sort_way: '', align: ''},
        {key: 'notes', name: 'Σημειώσεις', sortable: true, sort_way: '', align: ''},
    ];

    let search = {
        start_at: '',
        end_at: '',
        name: "",
        username: "",
    }

    const close = () => {
        $app.selectedCreditsHistoryId = 0;
        router._go("/app");
    }

    const onSearchKeyUp = event => {
        if (event.key === 'Enter') {
            loadHistory();
        }
    }

    const clearSearch = () => {
        search.start_at = '';
        search.end_at = '';
        search.name = "";
        search.username = "";
    }

    const onSort = ({detail:column}) => {
        sort_key = column.key;
        sort_way = column.sort_way;
        loadHistory(column.key, column.sort_way);
    }

    const onEntryChange = ({detail}) => {
        save(detail);
    }

    const loadHistory = async () => {
        let start_at = formatDate(search.start_at, 'yyyy-mm-dd');
        let end_at = formatDate(search.end_at, 'yyyy-mm-dd');

        const [err, res] = await getCreditsHistory({ start_at, end_at, name: search.name, username: search.username, key: sort_key, sort_way });

        historyList = res.list;
        loaded = true;

        calculateTotals();
    }

    const save = async(entry) => {
        const [err, res] = await ClientCreditsHistorySave(entry);
        if (err) {
            error.show(err);
        } else {
            //success.show("Το ιστορικό ενημερώθηκε.");
            calculateTotals();
        }
    }


    const calculateTotals = () => {
        totalPrice = 0;
        totalPayment = 0;
        totalRest = 0;
        historyList.map(item => {
            if (item.payed && parseInt(item.payed) > 0) {
                totalPayment+= parseFloat(item.total_price, 2);
            }
            totalPrice+= parseFloat(item.total_price, 2);
        });
        totalRest = parseFloat(totalPrice - totalPayment).toFixed(2);
        totalPrice = totalPrice.toFixed(2);
        totalPayment = totalPayment.toFixed(2);
    }

</script>

<div class="page-header">
    <div class="page-title">Ιστορικό Μονάδων</div>
    <div class="controls">
        <div title="Ανανέωση λίστας" on:click|preventDefault="{ loadHistory }">
            <span class="icon"><i class="fa fa-refresh"></i></span>
            <span class="caption">Ανανέωση</span>
        </div>
        <div title="Κλείσιμο" on:click|preventDefault="{ close }">
            <span class="icon"><i class="fa fa-times"></i></span>
        </div>
    </div>
</div>

<div class="page">
    <div class="page-main">

        <div class="panel">
            <div class="panel-heading">
                ΑΝΑΖΗΤΗΣΗ
            </div>
            <div class="panel-body">
                <div class="row">
                    <div class="col-md-2 col-xs-6">
                        <div class="form-group">
                            <label>ΑΠΟ</label>
                            <input type="date" bind:value="{ search.start_at }" class="form-control" on:keyup="{ onSearchKeyUp }">
                        </div>
                    </div>
                    <div class="col-md-2 col-xs-6">
                        <div class="form-group">
                            <label>ΕΩΣ</label>
                            <input type="date" bind:value="{ search.end_at }" class="form-control" on:keyup="{ onSearchKeyUp }">
                        </div>
                    </div>
                    <div class="col-md-2 col-xs-6">
                        <div class="form-group">
                            <label>ΟΝΟΜΑ</label>
                            <input type="text" bind:value="{ search.name }" class="form-control" on:keyup="{ onSearchKeyUp }">
                        </div>
                    </div>
                    <div class="col-md-2 col-xs-6">
                        <div class="form-group">
                            <label>ΟΝΟΜΑ ΧΡΗΣΤΗ</label>
                            <input type="text" bind:value="{ search.username }" class="form-control" on:keyup="{ onSearchKeyUp }">
                        </div>
                    </div>

                    <div class="col-md-4 col-xs-12 text-right">
                        <div class="label-spacer"></div>
                        <button class="btn btn-primary block-for-xs" on:click="{ loadHistory }">ΕΥΡΕΣΗ</button>
                        <button class="btn btn-default block-for-xs mrg-b-none" on:click="{ clearSearch }">ΚΑΘΑΡΙΣΜΟΣ
                        </button>
                    </div>
                </div>

            </div>
        </div> <!-- /search -->

        <div class="panel">
            <div class="panel-heading">
                ΙΣΤΟΡΙΚΟ ΜΟΝΑΔΩΝ
                {#if (historyList.length > 0)}
                    <span class="total">({ historyList.length })</span>
                {/if}
            </div>
            {#if historyList.length}
                <div class="table-responsive">
                    <table class="table table-bordered table-list table-data mrg-b-none">
                        <TableHeader table_columns="{ table_columns }" on:sort="{ onSort }"/>
                        <tbody>
                        {#each historyList as entry}
                            <CreditsHistoryRow entry="{ entry }" on:entry_change="{ onEntryChange }" />
                        {/each}
                        </tbody>
                    </table>
                </div>
                <div class="panel-body">
                    <div class="mrg-t-lg mrg-b-lg">
                    Σύνολο: <strong>{ totalPrice }</strong>, Πληρωμή: <strong>{ totalPayment }</strong>
                    {#if totalRest > 0}
                        , Υπόλοιπο: <strong>{ totalRest }</strong>
                    {/if}
                </div>
                </div>
            {:else}
                <div class="panel-body">
                    {#if !loaded}
                        <p>Επιλέξτε κριτήρια αναζήτησης.</p>
                    {:else}
                        <p>Δεν βρέθηκε ιστορικό μονάδων με αυτά τα κριτήρια αναζήτησης.</p>
                    {/if}
                </div>
            {/if}
        </div>

    </div>
</div>

